module.exports = __webpack_public_path__ + "img/wygeneruj_fakture.362565cf.svg";